import React from 'react';

// Base Components
import LayoutContent from 'common/oldJavascripts/components/Base/Layout/LayoutContent';

// Components

import OffersTable from './Archives/OffersTable';
import ManualArchives from './Archives/ManualArchives';

// HoC
import withPermissionProtection from 'common/hoc/withPermissionProtection';

const Archives = () => (
  <LayoutContent data-test-id="Archives-root">
    <ManualArchives />
    <OffersTable />
  </LayoutContent>
);

export default withPermissionProtection('can_access_archives')(Archives);
